var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getComponent(_vm.properties['textType']),{tag:"component",staticClass:"pa-0"},[_c('div',{class:_vm.cssClass},[_vm._v("  "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }